// src/components/bodyBlocks/profesionalBlock/editarProfesional/EditaDatosProfesional.tsx

import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import EditarFormulario from "../../../forms/editarPerfilForm/EditarFormularioForm";
import { PerfilProfesional } from "@/types";

// 🟢 Variable de entorno para la URL base del backend
import { safeFetch } from "@/api/safeFetch";

const EditaDatosProfesional: React.FC = () => {
  const { profesionId, profesionalId, perfilId } = useParams<{
    profesionId?: string;
    profesionalId?: string;
    perfilId?: string;
  }>();
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [datosPerfilProfesional, setDatosPerfilProfesional] =
    useState<PerfilProfesional | null>(null);

  useEffect(() => {
    if (!profesionId || !profesionalId || !perfilId) {
      setError("Faltan parámetros para cargar el perfil");
      setLoading(false);
      return;
    }

    // Limpiar estado antiguo
    setDatosPerfilProfesional(null);
    setError(null);
    setLoading(true);

    const fetchDatos = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) throw new Error("Token de autenticación no encontrado");

        // ✅ Llamada al backend usando safeFetch (no hace falta VITE_BACKEND_URL aquí)
        const res = await safeFetch(
          `/api/editaDatosProfesional/${encodeURIComponent(profesionId)}/${encodeURIComponent(profesionalId)}/${encodeURIComponent(perfilId)}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        if (!res.ok)
          throw new Error(`HTTP ${res.status} — Error al cargar el perfil`);

        const data: PerfilProfesional[] = await res.json();
        if (Array.isArray(data) && data.length > 0) {
          setDatosPerfilProfesional(data[0]);
        } else {
          throw new Error("El backend devolvió un array vacío");
        }
      } catch (err: any) {
        console.error("Error obteniendo los datos del perfil:", err);
        setError(err.message || "Error inesperado");
      } finally {
        setLoading(false);
      }
    };

    fetchDatos();
  }, [profesionId, profesionalId, perfilId]); // ✅ incluye perfilId

  if (loading) {
    return (
      <div className="flex justify-center items-center">
        <div className="relative">
          <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-gray-900"></div>
          <div className="absolute inset-0 flex items-center justify-center">
            <p className="text-zinc-900 font-semibold">Cargando...</p>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center mt-10 text-red-600 font-semibold">
        {error}
      </div>
    );
  }

  if (!datosPerfilProfesional) {
    return (
      <div className="text-center mt-10 text-zinc-500">
        No hay datos disponibles
      </div>
    );
  }

  return (
    <div className="flex flex-col rounded-2xl sm:mx-9 xs:mx-4 pt-16 md:pt-10">
      <div className="flex justify-center">
        <div className="sm:p-6 xs:p-4 rounded-2xl shadow-2xl border-black border border-b-2 border-r-8 w-full mb-8">
          <EditarFormulario
            datosPerfilProfesional={{
              ...datosPerfilProfesional,
              perfil_profesional_id: Number(
                datosPerfilProfesional.perfil_profesional_id,
              ),
            }}
            profesionalId={profesionalId!}
            profesionId={profesionId!}
            perfilId={perfilId!}
          />
        </div>
      </div>
    </div>
  );
};

export default EditaDatosProfesional;
